import Header from "../components/Header";
import Footer from "../components/Footer";
import MobileStickyCTA from "../components/MobileStickyCTA";
import QuoteForm from "../components/QuoteForm";
import HeadTags from "../seo/HeadTags";
import { cleaningBusinessSchema, breadcrumbSchema } from "../seo/schema";
import { CLEANING_CANONICAL_ORIGIN, HVAC_PROMO_HREF } from "../seo/hosts";
import { cleaningSameAs } from "../data/cleaningContent";
import { BUSINESS } from "../data/business";
import Hero from "../components/sections/Hero";
import TrustBar from "../components/sections/TrustBar";
import About from "../components/sections/About";
import ServicesGrid from "../components/sections/ServicesGrid";
import ServiceDetails from "../components/sections/ServiceDetails";
import WhyChoose from "../components/sections/WhyChoose";
import BeforeAfter from "../components/sections/BeforeAfter";
import Reviews from "../components/sections/Reviews";
import ServiceArea from "../components/sections/ServiceArea";
import Policies from "../components/sections/Policies";

export default function Home() {
  return (
    <div className="bg-white pb-mobile-cta" data-testid="home-page">
      <HeadTags
        title="S.S. Cleaning Solutions | Residential & Commercial Cleaning in Northwest Indiana"
        description="Locally owned residential & commercial cleaning in Northwest Indiana. Standard, deep, recurring, move-in/out, office and church cleaning across Lake Station, Hobart, Portage, Gary, Merrillville, Hammond and surrounding areas. Request a free quote."
        path="/"
        image={BUSINESS.logoOg}
        favicon={BUSINESS.logoIcon}
        siteName="S.S. Cleaning Solutions"
        schemas={[
          cleaningBusinessSchema({ sameAs: cleaningSameAs() }),
          breadcrumbSchema([
            { name: "Home", url: `${CLEANING_CANONICAL_ORIGIN}/` },
          ]),
        ]}
      />
      <Header />
      <main>
        <Hero />
        <TrustBar />

        {/* Quote near top */}
        <section id="quote" className="section pt-12 md:pt-16">
          <div className="container-ss grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
            <div className="lg:col-span-5">
              <span className="pill mb-3">Free Quote</span>
              <h2 className="font-display text-3xl md:text-4xl font-semibold text-slate-900 leading-tight">
                Tell us about your space — we'll send a <span className="text-[#059669]">free quote</span>.
              </h2>
              <p className="text-slate-600 mt-3">
                Most requests get a response the same day. Prefer to talk? Call or text us at
                <a href="tel:+12194551453" className="text-[#1E3A8A] font-semibold"> 219-455-1453</a>.
              </p>
              <ul className="mt-6 space-y-3 text-slate-700 text-sm">
                <li>✓ Friendly, no-pressure quotes</li>
                <li>✓ Pictures help us be more accurate</li>
                <li>✓ One-time, recurring & commercial</li>
              </ul>
            </div>
            <div className="lg:col-span-7">
              <QuoteForm />
            </div>
          </div>
        </section>

        <About />
        <ServicesGrid />
        <ServiceDetails />
        <WhyChoose />
        <BeforeAfter />
        <Reviews />
        <ServiceArea />
        <Policies />

        {/* Subtle HVAC cross-promotion — family also runs Lee's Heating &amp; Cooling */}
        <section className="section py-14 md:py-16 bg-[#0B1A3F] text-white" data-testid="home-hvac-promo">
          <div className="container-ss text-center max-w-3xl mx-auto">
            <p className="text-[11px] uppercase tracking-[0.28em] text-emerald-300 font-semibold mb-3">
              Also from our family
            </p>
            <h2 className="font-display text-3xl md:text-4xl font-semibold leading-tight">
              Need Heating or Air Conditioning Service?
            </h2>
            <p className="mt-4 text-slate-300 leading-relaxed text-base md:text-lg">
              Our family also proudly offers professional heating and cooling services throughout
              Northwest Indiana through Lee&apos;s Heating &amp; Cooling.
            </p>
            <a
              href={HVAC_PROMO_HREF}
              className="inline-flex items-center gap-2 mt-7 px-6 py-3 rounded-full bg-white text-[#0B1A3F] font-semibold text-sm hover:bg-slate-100 transition-colors"
              data-testid="home-hvac-cta"
            >
              Visit Our HVAC Services →
            </a>
          </div>
        </section>
      </main>
      <Footer />
      <MobileStickyCTA />
    </div>
  );
}
